import { AfterViewInit, DestroyRef, Directive, ElementRef, inject, OnDestroy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NzTableComponent } from 'ng-zorro-antd/table';
import { stampTableCardLabels } from '../core/utils/table-card-labels';

/** BAO-995: every nz-table gets card labels, not only ListComponentGeneric. */
@Directive({
  selector: 'nz-table',
  standalone: false
})
export class TableCardLabelsDirective implements AfterViewInit, OnDestroy {

  private readonly _el = inject(ElementRef<HTMLElement>);
  private readonly _table = inject(NzTableComponent, { optional: true, self: true });
  private readonly _destroyRef = inject(DestroyRef);
  private _obs?: MutationObserver;
  private _raf = 0;

  ngAfterViewInit(): void {
    this.scheduleStamp();
    this._table?.nzCurrentPageDataChange
      .pipe(takeUntilDestroyed(this._destroyRef))
      .subscribe(() => this.scheduleStamp());

    this._obs = new MutationObserver(() => this.scheduleStamp());
    this._obs.observe(this._el.nativeElement, { childList: true, subtree: true });
  }

  ngOnDestroy(): void {
    this._obs?.disconnect();
    if (this._raf) {
      cancelAnimationFrame(this._raf);
    }
  }

  private scheduleStamp(): void {
    if (this._raf) {
      cancelAnimationFrame(this._raf);
    }
    this._raf = requestAnimationFrame(() => {
      this._raf = 0;
      stampTableCardLabels(this._el.nativeElement);
    });
  }
}
